import React, { Component } from "react";
import ReactDOM from "react-dom";
import cn from "classnames";
import Layout from "../Layout";
import "./FillLayout.less";

const CLASS_NAME = "fct-fill-layout";

class FillLayout extends Component {
  render() {
    const { children, className, ...props } = this.props;
    return (
      <Layout className={cn(CLASS_NAME, className)} {...props}>
        {children}
      </Layout>
    );
  }
}

export default FillLayout;



// WEBPACK FOOTER //
// ./layout/fill/FillLayout.js